export default __webpack_public_path__ + "static/media/citation-download.9774abe5.svg";